document.addEventListener("DOMContentLoaded", function() {
  // Loop over each slider container on the page
  document.querySelectorAll('.mySwiper').forEach(function(sliderEl) {
    // Parse the JSON settings from the data attribute
    var settings = JSON.parse(sliderEl.getAttribute('data-slider-settings'));

    var desktopSlides = settings.desktopSlides || 5.5;
    var mobileSlides  = settings.mobileSlides || 4;
    var autoplayEnabled = settings.autoplayEnabled || false;
    var autoplayDelay = settings.autoplayDelay || 3000;
    var autoScrollDirection = settings.autoScrollDirection || "right";
    var gap = settings.gap || 0; // default gap

    // Build the configuration object for this slider instance.
    var swiperConfig = {
      loop: true,
      slidesPerView: mobileSlides,
      centeredSlides: true,
      spaceBetween: gap, // Add the gap here (in px)
      navigation: {
        // Make sure your navigation buttons are uniquely scoped or within the same container.
        nextEl: sliderEl.closest('.container--not-mobile').querySelector(".only-for-product-lp-next"),
        prevEl: sliderEl.closest('.container--not-mobile').querySelector(".only-for-product-lp-prev")
      },
      pagination: {
        el: sliderEl.closest('.container--not-mobile').querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: desktopSlides
        }
      },
      direction: "horizontal"
    };

    // Add autoplay if enabled
    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,      // in milliseconds
        disableOnInteraction: false,
        reverseDirection: autoScrollDirection === "left"
      };
    }
    
    // Initialize a new Swiper instance for this slider element.
    new Swiper(sliderEl, swiperConfig);
  });
});
